export const ROTULO_CONDICAO = {
    NOVA: 'Nova',
    USADA: 'Usada',
};
/** Texto do badge no card da vitrine — caixa alta, como no protótipo. */
export const BADGE_CONDICAO = {
    NOVA: 'NOVA',
    USADA: 'USADA',
};
export const ROTULO_STATUS = {
    RASCUNHO: 'Rascunho',
    DISPONIVEL: 'Disponível',
    RESERVADA: 'Reservada',
    VENDIDA: 'Vendida',
};
export const ROTULO_ORDENACAO = {
    destaque: 'Destaques',
    recentes: 'Mais recentes',
    preco_asc: 'Menor preço',
    preco_desc: 'Maior preço',
    nome_asc: 'Nome (A-Z)',
};
export const ROTULO_CATEGORIA = {
    mtb: 'Mountain Bike',
    urbana: 'Urbana',
    speed: 'Speed',
    infantil: 'Infantil',
    bmx: 'BMX',
    eletrica: 'Elétrica',
};
export function rotularCategoria(valor) {
    if (!valor)
        return '';
    return ROTULO_CATEGORIA[valor] ?? valor;
}
//# sourceMappingURL=rotulos.js.map